module.exports = __webpack_public_path__ + "static/media/success.832c4b6f.svg";